<template>
  <div class="news-list">
    <news-Item
      v-for="news in newsList"
      :key="news.id"
      :id = "news.id"
      :public = "news.public"
      :title = "news.title"
      :short-description = "news.shortDescription"
      :image-src = "news.imageSrc"
      :format-html = "news.formatHtml"
    />
  </div>
</template>
<script>
import timeCombaine from '@/components/mixins/timeCombaine';
import appBaseNav from '@/components/mixins/appBaseNav';
import news from '@/components/mixins/api/apiMethodsNews';
import newsItem from '@/components/shared/upCard/NewsCard/NewsItem.vue';

export default {
  name: 'NewsListView',
  data() {
    return {
      newsList: () => ([]),
      isLoading: true,
    };
  },
  mixins: [appBaseNav, news, timeCombaine],
  components: { newsItem },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('news.header_title'));
    this.getPage();
  },
  methods: {
    getPage() {
      this.isLoading = true;
      this.getNewsList()
        .then((data) => {
          this.newsList = data.results.map((item) => ({
            id: item.id,
            public: {
              date: `${this.dateEventShort(item.public_ts)}`,
              time: `${this.timeEvent(item.public_ts)}`,
            },
            title: item.title,
            shortDescription: item.short_description,
            imageSrc: item.preview,
            formatHtml: item.description_format !== 'text',
          }));
          console.log(data);
          this.isLoading = false;
        })
        .catch();
    },
  },
};
</script>
<style lang="scss">
.news-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 12px;
}
</style>
